import { createSelector } from 'reselect';
import { appSettingsSelectionReducer, appSettingsSelectionSliceeType } from './app-settings-reducer';

export const appSettingsSelectionSliceSelector = (state: any): any => state[appSettingsSelectionReducer.sliceName];

export const appSettingsSliceSelector = createSelector(
  appSettingsSelectionSliceSelector,
  (appSettingsSelectionSlice: appSettingsSelectionSliceeType) => appSettingsSelectionSlice.app_settings,
);
